import React from "react";
import { ErrorMessage, useFormikContext } from "formik";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { TextareaAutosize } from "@mui/material";
import { titleCase } from "../../CommonFuntion/SchemaValidation";
const CssTextField = styled(TextField)({});
const blue = {
  100: "#0d6efd",
  // 100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#212529",
  // 50: "#f6f8fa",
  100: "#eaeef2",
  200: "#d0d7de",
  300: "#afb8c1",
  400: "#8c959f",
  500: "#6e7781",
  600: "#57606a",
  700: "#424a53",
  800: "#32383f",
  900: "#24292f",
};
const StyledTextarea = styled(TextareaAutosize)(
  ({ theme }) => `
  width: 200px;
 

  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
 


  &:hover {
    border-color: ${blue[50]};
    border: 2px solid ${theme.palette.mode === "dark" ? grey[50] : grey[50]};
  }

  &:focus {
    border-color: ${blue[100]};
    border: 2px solid ${theme.palette.mode === "dark" ? blue[100] : blue[100]};
   

  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

export function TextArea(props) {
  const { name, label, tagName, validation, prefix } = props;
  const { setFieldValue, values } = useFormikContext();
  const id = `${tagName}-input`;
  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue([name], value);
  };

  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" htmlFor={id}>
              {titleCase(label.replace("_", " "))}
              {validation?.mandatory && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl>
            <Tooltip
              title={
                validation.pictureMask
                  ? "Picture Mask:" + validation.pictureMask
                  : ""
              }
            >
              <StyledTextarea
                name={name}
                key={name}
                tagname={tagName}
                prefix={prefix}
                value={values?.[name] || ""}
                onChange={handleChange}
                maxRows={2}
                minRows={2}
                id={id}
              />
            </Tooltip>
          </FormControl>

          <ErrorMessage
            name={name}
            render={(msg) => {
              return <div className="is-invalid">{msg}</div>;
            }}
          />
        </div>
      </div>
    </>
  );
}
